import { bootFunctions } from  'login/boot'
import { boot, setupBoot } from 'core/boot'

setupBoot(bootFunctions)
boot()
